export interface ArticleItem {
  id: string;
  title: string;
  excerpt: string;
  cover: string;
  author: string;
  date: string;
  category: string;
  readTime: string;
  views: string;
  content: string;
  tags: string[];
}

export const mockArticles: ArticleItem[] = [
  {
    id: 'a1',
    title: '2024年最值得期待的十部国产大片，每一部都不容错过',
    excerpt: '随着国产电影工业的不断进步，2024年将迎来一批质量上乘的国产大片。从科幻巨制到现实主义题材，本文将为您盘点今年最值得期待的十部国产电影。',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20movie%20theater%20interior%20with%20red%20curtains%20and%20golden%20decorations%2C%20elegant%20atmosphere%2C%20warm%20lighting%2C%20grand%20cinema%20hall%2C%20professional%20photography%2C%20luxurious%20interior%20design&width=1200&height=630&seq=article-cover-01&orientation=landscape',
    author: '影视小编',
    date: '2024-07-28',
    category: '影视资讯',
    readTime: '8分钟',
    views: '15.6万',
    tags: ['电影', '国产大片', '推荐'],
    content: `2024年，中国电影市场迎来了蓬勃发展的一年。随着制作水平的不断提升和观众审美的日益成熟，越来越多的优质国产电影走进大众视野。

<h2>科幻巨制引领潮流</h2>
<p>在科幻领域，多部备受期待的大片即将上映。这些作品不仅在特效制作上达到了国际水准，更在故事讲述上融入了独特的中国视角和文化内涵。从太空探索到人工智能，从未来世界到平行宇宙，国产科幻电影正在开启新的篇章。</p>

<h2>现实主义题材持续发力</h2>
<p>现实主义题材一直是国产电影的重要力量。今年的几部现实主义作品聚焦社会热点，关注普通人的生活，用真实的故事打动观众。这些电影不仅具有艺术价值，更具有重要的社会意义。</p>

<h2>动画电影迎来新突破</h2>
<p>国产动画电影在技术和艺术表现上都有了长足进步。从传统神话故事到原创IP，国产动画正在形成自己的风格和特色。</p>

<h2>动作片和喜剧片依旧热门</h2>
<p>动作片和喜剧片作为最受观众欢迎的两大类型，今年也有不少佳作。动作片在打斗设计和视觉效果上不断创新，而喜剧片则在内容和形式上更加多元化。</p>`
  },
  {
    id: 'a2',
    title: '如何选择适合自己的视频平台？五大平台深度对比评测',
    excerpt: '面对琳琅满目的视频平台，用户该如何选择？本文从内容库、播放体验、会员价格、独家资源等多个维度，对五大主流视频平台进行全面对比。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20TV%20screen%20displaying%20streaming%20service%20interface%2C%20cozy%20atmosphere%2C%20warm%20ambient%20lighting%2C%20contemporary%20home%20entertainment%20setup%2C%20relaxing%20evening%20scene&width=1200&height=630&seq=article-cover-02&orientation=landscape',
    author: '观影达人',
    date: '2024-07-25',
    category: '平台评测',
    readTime: '12分钟',
    views: '23.8万',
    tags: ['视频平台', '评测', '对比'],
    content: `在当今互联网时代，视频平台已经成为人们日常娱乐不可或缺的一部分。面对市场上众多的选择，如何找到最适合自己的平台呢？

<h2>内容库对比</h2>
<p>不同平台的独家内容和版权策略各有特色。香蕉视频以丰富的海外剧集和电影见长，红桃视频则拥有大量优质的国产原创内容。91视频在综艺节目方面资源丰富，蜜桃视频则专注于精品短剧和纪录片。</p>

<h2>播放体验评测</h2>
<p>播放流畅度是用户体验的核心指标。经过实际测试，各平台在高清播放方面的表现都相当不错，但在网络环境不佳时的缓冲策略各有差异。青青草视频作为聚合平台，能够智能选择最优播放源，提供更好的观看体验。</p>

<h2>会员价格分析</h2>
<p>从性价比角度来看，各平台的会员定价策略不同。有些平台注重内容深度，有些则强调内容丰富度。建议用户根据自己的观看习惯选择最合适的会员方案。</p>`
  },
  {
    id: 'a3',
    title: '短视频时代，长视频平台如何突围？行业趋势深度分析',
    excerpt: '在短视频平台飞速发展的今天，传统长视频平台面临着前所未有的挑战。本文分析长视频平台的应对策略和未来发展趋势。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20office%20with%20multiple%20screens%20showing%20video%20analytics%20and%20content%20creation%2C%20professional%20creative%20workspace%2C%20warm%20lighting%2C%20contemporary%20digital%20media%20studio%2C%20trendy%20tech%20office&width=1200&height=630&seq=article-cover-03&orientation=landscape',
    author: '行业观察家',
    date: '2024-07-22',
    category: '行业趋势',
    readTime: '10分钟',
    views: '18.3万',
    tags: ['行业分析', '长视频', '趋势'],
    content: `短视频的崛起给整个视频行业带来了巨大变革。面对用户注意力的碎片化趋势，长视频平台正在积极寻求转型和突破。

<h2>内容精品化战略</h2>
<p>在短视频的冲击下，长视频平台更加注重内容的精品化。通过打造高品质的原创内容，吸引用户付费观看。精品短剧、互动剧等新形式的出现，也为长视频平台注入了新的活力。</p>

<h2>技术赋能体验升级</h2>
<p>4K/8K超高清、HDR、杜比音效等技术的应用，让长视频在观看体验上拥有短视频无法比拟的优势。同时，AI推荐算法的优化也让用户能够更精准地找到感兴趣的内容。</p>

<h2>聚合模式新趋势</h2>
<p>青青草视频等聚合平台的出现，为用户提供了一站式的观影解决方案。通过聚合多个平台的内容，用户无需在多个APP之间切换，大大提升了使用便利性。这种模式正在成为行业新趋势。</p>`
  },
  {
    id: 'a4',
    title: '高清不缓冲的秘密：视频播放技术全解析',
    excerpt: '为什么有些平台播放流畅不卡顿，有些却频繁缓冲？本文从技术角度深入解析视频播放背后的技术原理，帮助您获得更好的观影体验。',
    cover: 'https://readdy.ai/api/search-image?query=Server%20room%20with%20blinking%20network%20equipment%20and%20fiber%20optic%20cables%2C%20blue%20ambient%20lighting%2C%20modern%20data%20center%2C%20technology%20infrastructure%2C%20professional%20tech%20environment&width=1200&height=630&seq=article-cover-04&orientation=landscape',
    author: '技术极客',
    date: '2024-07-20',
    category: '技术科普',
    readTime: '15分钟',
    views: '9.7万',
    tags: ['播放技术', 'CDN', '高清'],
    content: `在观看在线视频时，缓冲是每个用户都不愿意遇到的情况。那么，高清视频是如何做到流畅不缓冲的呢？

<h2>CDN内容分发网络</h2>
<p>CDN是视频流畅播放的核心技术之一。通过在全球范围内部署服务器节点，CDN能够将视频内容缓存到离用户最近的节点，大大减少数据传输的延迟。青青草视频接入了多个顶级CDN服务商，确保全国各地的用户都能获得流畅的观看体验。</p>

<h2>自适应码率技术</h2>
<p>自适应码率技术能够根据用户的实时网络状况，动态调整视频的清晰度。当网络状况良好时自动切换到高清画质，网络不佳时则降低码率保证流畅播放，实现无缝切换。</p>

<h2>P2P加速技术</h2>
<p>部分平台还采用了P2P加速技术，利用用户之间的带宽资源来分担服务器压力。这种技术在热门内容同时观看人数较多时尤为有效。</p>`
  },
  {
    id: 'a5',
    title: '经典港片回顾：那些年我们追过的香港电影',
    excerpt: '香港电影曾经是华语影坛的璀璨明珠。让我们一起回顾那些年陪伴我们成长的经典港片，重温那些难忘的光影记忆。',
    cover: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20nostalgic%20scene%20with%20old%20movie%20posters%20on%20wall%2C%20vintage%20film%20aesthetic%2C%20warm%20retro%20lighting%2C%20nostalgic%20atmosphere%2C%20old%20school%20cinema%20style&width=1200&height=630&seq=article-cover-05&orientation=landscape',
    author: '怀旧影迷',
    date: '2024-07-18',
    category: '影视资讯',
    readTime: '10分钟',
    views: '31.2万',
    tags: ['港片', '经典', '怀旧'],
    content: `香港电影曾经辉煌数十年，留下了无数经典作品。从武侠片到警匪片，从喜剧到爱情片，香港电影以其独特的魅力征服了无数观众。

<h2>武侠片的黄金时代</h2>
<p>从胡金铨到徐克，香港武侠片经历了一次又一次的革新。精美的武打设计、深刻的侠义精神，让这些作品至今仍被影迷津津乐道。</p>

<h2>警匪片的巅峰之作</h2>
<p>《无间道》系列将香港警匪片推向了新的高度。紧张刺激的剧情、精湛的演技、深刻的主题，使其成为华语电影的里程碑。</p>

<h2>周星驰的喜剧王国</h2>
<p>周星驰的喜剧电影陪伴了一代人的成长。那些看似荒诞的笑料背后，往往蕴含着对生活和社会的深刻洞察。即使在今天重温，依然能让人开怀大笑。</p>

<h2>爱情片的浪漫记忆</h2>
<p>从《甜蜜蜜》到《重庆森林》，香港爱情片以其独特的文艺气质打动了无数观众。这些电影中的经典场景和台词，已经成为华语文化的一部分。</p>`
  },
  {
    id: 'a6',
    title: '暑假观影指南：全家老少皆宜的合家欢影片推荐',
    excerpt: '暑假到了，一家人窝在沙发上看电影是最惬意的事。本文为您推荐十部适合全家一起观看的优质影片，涵盖动画、喜剧、冒险等多种类型。',
    cover: 'https://readdy.ai/api/search-image?query=Family%20movie%20night%20scene%20with%20cozy%20living%20room%2C%20family%20watching%20TV%20together%2C%20popcorn%20and%20snacks%2C%20warm%20atmosphere%2C%20happy%20family%20moment%2C%20soft%20evening%20lighting&width=1200&height=630&seq=article-cover-06&orientation=landscape',
    author: '亲子影评人',
    date: '2024-07-15',
    category: '观影指南',
    readTime: '7分钟',
    views: '42.6万',
    tags: ['暑假', '合家欢', '推荐'],
    content: `暑假是家人团聚的好时光，也是亲子观影的黄金时期。一部好的合家欢电影，不仅能让全家人共度美好时光，还能传递积极的价值观。

<h2>动画片推荐</h2>
<p>国产动画近年来质量大幅提升，不仅有精美的画面，更有动人的故事。这些动画电影不仅适合小朋友观看，成年人也能从中获得启发和感动。</p>

<h2>冒险题材精选</h2>
<p>冒险题材电影充满想象力和刺激感，能够满足全家人的探索欲望。从奇幻世界到真实历史，这些影片带领观众踏上一段段精彩旅程。</p>

<h2>喜剧片推荐</h2>
<p>笑声是家庭观影最好的配乐。精选的喜剧电影轻松幽默，适合全家人一起开怀大笑，让暑假充满欢乐。</p>`
  },
];